import { Component, OnInit } from "@angular/core";

@Component({
    selector: "app-courses-must-review",
    templateUrl: "./courses-must-review.component.html",
    styleUrls: ["./courses-must-review.component.scss"]
})
export class CoursesMustReviewComponent implements OnInit {
    constructor() {}

    ngOnInit() {}
}
